{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "(okoa {highestYearlyDiscount}%)",
    "{amount} days free": "siku {amount} bila malipo",
    "{amount} off": "punguzo la {amount}",
    "{amount} off for first {number} months.": "punguzo la {amount} kwa miezi {number} ya kwanza.",
    "{amount} off for first {period}.": "punguzo la {amount} kwa {period} ya kwanza.",
    "{amount} off forever.": "punguzo la {amount} milele.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "punguzo la {discount}%",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} haitapokea jarida la {newsletterName} tena.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} haitapokea barua pepe tena wakati mtu anapojibu maoni yako.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} haitapokea jarida hili tena.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "siku {trialDays} bila malipo",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Akaunti",
    "Account details updated successfully": "",
    "Account settings": "Mipangilio ya akaunti",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Baada ya kipindi cha majaribio bila malipo kukamilika, utatozwa bei ya kawaida kwa kiwango ulichochagua. Unaweza kughairi kabla ya hapo.",
    "Already a member?": "Tayari ni mwanachama?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Kumetokea hitilafu isiyotarajiwa. Tafadhali jaribu tena au <a>wasiliana na usaidizi</a> ikiwa hitilafu itaendelea.",
    "Back": "Rudi",
    "Back to Log in": "Rudi kuingia",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Ijumaa ya punguzo (Black Friday)",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Ghairi wakati wowote.",
    "Cancel subscription": "Ghairi usajili",
    "Canceled": "",
    "Cancellation reason": "Sababu ya kughairi",
    "Change": "Badilisha",
    "Change plan": "",
    "Check spam & promotions folders": "Kagua folda za spam & matangazo",
    "Check with your mail provider": "Thibitisha na mtoa huduma wako wa barua",
    "Check your inbox to verify email update": "",
    "Choose": "Chagua",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Chagua mpango tofauti",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "Chagua majarida yako",
    "City": "",
    "Click here to retry": "Bofya hapa kurudia",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Funga",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Maoni",
    "Complimentary": "Bure",
    "Confirm": "Thibitisha",
    "Confirm cancellation": "Thibitisha kughairi",
    "Confirm subscription": "Thibitisha usajili",
    "Contact support": "Wasiliana na wasaidizi",
    "Continue": "Endelea",
    "Continue subscription": "Endelea na usajili",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Haikuweza kuingia. Kiungo cha kuingia kimeisha muda.",
    "Could not update email! Invalid link.": "Haikuweza kusasisha barua pepe! Kiungo batili.",
    "Country": "",
    "Create a new contact": "Unda mawasiliano mapya",
    "Current plan": "Mpango wa sasa",
    "Delete account": "Futa akaunti",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Hukumaanisha kufanya hivi? Dhibiti mapendeleo yako <button>hapa</button>.",
    "Don't have an account?": "Huna akaunti?",
    "Edit": "Hariri",
    "Email": "Barua pepe",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Jarida la barua pepe",
    "Email newsletter settings updated": "",
    "Email preferences": "Mapendeleo ya barua pepe",
    "Email preferences updated.": "",
    "Emails": "Barua pepe",
    "Emails disabled": "Barua pepe zimezimwa",
    "Ends {offerEndDate}": "Inaisha {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Hitilafu",
    "Expires {expiryDate}": "Inaisha {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Milele",
    "Free Trial – Ends {trialEnd}": "Jaribio la Bure – linaisha {trialEnd}",
    "From": "",
    "Get help": "Pata msaada",
    "Get in touch for help": "Wasiliana kupata msaada",
    "Get notified when someone replies to your comment": "Pata taarifa wakati mtu anapojibu maoni yako",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Toa maoni kuhusu chapisho hili",
    "Help! I'm not receiving emails": "Msaada! Sipokei barua pepe",
    "Here are a few other sites you may enjoy.": "Hapa kuna tovuti chache nyingine unazoweza kufurahia.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Ikiwa jarida limewekwa alama kama spam, barua pepe zinazimwa kiotomatiki kwa anwani hiyo kuhakikisha haupokei ujumbe usiotakiwa tena.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Ikiwa malalamiko ya spam yalikuwa ya bahati mbaya, au ungependa kuanza kupokea barua pepe tena, unaweza kujiandikisha tena kwa barua pepe kwa kubofya kitufe kwenye skrini iliyopita.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Ikiwa utaghairi usajili wako sasa, utaendelea kupata huduma hadi {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Ikiwa una akaunti ya barua pepe ya kampuni au serikali, wasiliana na idara yako ya IT na uwaombe waruhusu kupokea barua pepe kutoka {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Kiungo cha kuingia kimetumwa kwenye inbox yako. Kama hakifiki ndani ya dakika 3, hakikisha unakagua folda yako ya spam.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Ikiwa ungependa kuanza kupokea barua pepe tena, hatua bora zinazofuata ni kukagua anwani yako ya barua pepe kwa ajili ya matatizo yoyote kisha ubofye jiandikishe tena kwenye skrini iliyopita.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Ikiwa hupokei jarida la barua pepe ulilojiandikisha nalo, hapa kuna mambo machache ya kukagua.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Ikiwa umekamilisha ukaguzi huu wote na bado hupokei barua pepe, unaweza kupata usaidizi kwa kuwasiliana na {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Ikiwa itapokea hitilafu ya kudumu wakati wa kujaribu kutuma jarida, barua pepe zitazimwa kwenye akaunti.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Kwenye mteja wako wa barua pepe ongeza {senderEmail} kwenye orodha yako ya mawasiliano. Hii inaashiria kwa mtoa huduma wako wa barua kwamba barua pepe zilizotumwa kutoka anwani hii zinapaswa kuaminika.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Punguza kama hii",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Hakikisha barua pepe hazijakosekana kufikia folda za Spam au Matangazo ya kikasha chako. Ikiwa ziko, bonyeza \"Alama kama si spam\" na/au \"Hamisha kwenye kikasha\".",
    "Manage": "Dhibiti",
    "Maybe later": "Labda baadaye",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Uanachama haupatikani, wasiliana na mmiliki kupata ufikiaji.",
    "month": "",
    "Monthly": "Kila mwezi",
    "More like this": "Zaidi kama hii",
    "More options": "",
    "Name": "Jina",
    "Need more help? Contact support": "Unahitaji msaada zaidi? Wasiliana na usaidizi",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Majarida yanaweza kuzimwa kwenye akaunti yako kwa sababu mbili: Barua pepe ya awali iliyowekwa alama kama spam, au jaribio la kutuma barua pepe lilisababisha hitilafu ya kudumu (bounce).",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Hupokei barua pepe?",
    "Now": "",
    "Now check your email!": "Sasa angalia barua pepe yako!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Mara baada ya kujiandikisha tena, ikiwa bado huoni barua pepe kwenye kikasha chako, kagua folda yako ya spam. Watoa huduma wengine wa kikasha huweka rekodi ya malalamiko ya awali ya spam na wataendelea kuweka alama kwenye barua pepe. Ikiwa hili litatokea, weka alama kwenye jarida la hivi karibuni kama 'Si spam' ili kuirudisha kwenye kikasha chako kikuu.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Hitilafu ya kudumu (bounce)",
    "Phone number": "",
    "Plan": "Mpango",
    "Plan checkout was cancelled.": "Malipo ya mpango yalighairiwa.",
    "Plan upgrade was cancelled.": "Uboreshaji wa mpango ulighairiwa.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Tafadhali wasiliana na {supportAddress} kurekebisha usajili wako wa bure.",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Tafadhali jaza sehemu zinazohitajika",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "Washa tena barua pepe",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Mapendekezo",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Inajirudia kwa bei ya {price}.",
    "Resume subscription": "",
    "Retry": "Jaribu tena",
    "Save": "Hifadhi",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Inatuma kiungo cha kuingia...",
    "Sending...": "Inatuma...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Onyesha yote",
    "Sign in": "Ingia",
    "Sign out": "Toka",
    "Sign up": "Jisajili",
    "Signup error: Invalid link": "Kosa la usajili: Kiungo batili",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Samahani, hiyo haikufanya kazi.",
    "Spam complaints": "Malalamiko ya Spam",
    "Start {amount}-day free trial": "Anza majaribio ya siku {amount} bila malipo",
    "Starting {startDate}": "Inaanza {startDate}",
    "Starting today": "Inaanza leo",
    "State": "",
    "Submit feedback": "Tuma maoni",
    "Subscribe": "Jiunge",
    "Subscribed": "Umejiunga",
    "Subscription plan updated successfully": "",
    "Success": "Mafanikio",
    "Success! Check your email for magic link to sign-in.": "Mafanikio! Angalia barua pepe yako kwa kiungo cha kuingia.",
    "Success! Your account is fully activated, you now have access to all content.": "Mafanikio! Akaunti yako imeamilishwa kikamilifu, sasa una ufikiaji wa maudhui yote.",
    "Success! Your email is updated.": "Mafanikio! Barua pepe yako imesasishwa.",
    "Successfully unsubscribed": "Umejiondoa kwa mafanikio",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Asante kwa kujiunga. Kabla hujanza kusoma, hapa chini ni tovuti chache nyingine unazoweza kufurahia.",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Asante kwa maoni!",
    "That didn't go to plan": "Hiyo haikwenda kama ilivyopangwa",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Anwani ya barua pepe tuliyonayo kwako ni {memberEmail} — ikiwa hiyo si sahihi, unaweza kuisasisha kwenye <button>eneo la mipangilio ya akaunti</button> yako.",
    "There was a problem submitting your feedback. Please try again a little later.": "Kulikuwa na tatizo la kutuma maoni yako. Tafadhali jaribu tena baadaye kidogo.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Tovuti hii ni ya mialiko pekee, wasiliana na mmiliki kupata ufikiaji.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Kukamilisha usajili, bonyeza kiungo cha uthibitisho kwenye kikasha chako. Kama hakifiki ndani ya dakika 3, kagua folda yako ya spam!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Jaribu bila malipo kwa siku {amount}, kisha {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Fungua ufikiaji wa majarida yote kwa kuwa mwanachama anayelipa.",
    "Unsubscribe from all emails": "Jiondoe kwenye barua pepe zote",
    "Unsubscribed": "Umejiondoa",
    "Unsubscribed from all emails.": "Umejiondoa kwenye barua pepe zote.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Kujiondoa kutoka barua pepe hakuwezi kughairi usajili wako uliolipwa wa {title}",
    "Update": "Sasisha",
    "Update your preferences": "Sasisha mapendeleo yako",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Kiungo cha uthibitisho kimetumwa, angalia kikasha chako",
    "Verify your email address is correct": "Hakikisha anwani yako ya barua pepe ni sahihi",
    "Verifying...": "",
    "View plans": "Tazama mipango",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Hatukuweza kukuondoa kwenye usajili kwa sababu anwani ya barua pepe haikupatikana. Tafadhali wasiliana na mmiliki wa tovuti.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Karibu tena, {name}!",
    "Welcome back!": "Karibu tena!",
    "Welcome to {siteTitle}": "Karibu kwa {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Wakati kikasha kinaposhindwa kupokea barua pepe kwa kawaida huitwa bounce. Mara nyingi, hii inaweza kuwa ya muda. Hata hivyo, katika baadhi ya matukio, barua pepe iliyorudishwa inaweza kuonekana kama hitilafu ya kudumu wakati anwani ya barua pepe ni batili au haipo.",
    "Why has my email been disabled?": "Kwa nini barua pepe yangu imezimwa?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Kila mwaka",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Kwa sasa una uanachama bila malipo, boresha kuwa usajili uliolipwa kwa ufikiaji kamili.",
    "You have been successfully resubscribed": "Umejiandikisha tena kwa mafanikio",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Kwa sasa hupokei barua pepe",
    "You're not receiving emails": "Hupokei barua pepe",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Hupokei barua pepe kwa sababu umeashiria ujumbe wa hivi karibuni kama spam, au kwa sababu ujumbe haukuweza kuwasilishwa kwenye anwani yako ya barua pepe iliyotolewa.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Umeingia kwa mafanikio.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Umejiunga kwa mafanikio na <strong>{siteTitle}</strong>",
    "Your account": "Akaunti yako",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Maoni yako yanasaidia kuunda yaliyochapishwa.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Usajili wako utaisha tarehe {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Usajili wako utaongezwa tarehe {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Usajili wako utaanza tarehe {subscriptionStart}"
}
